import './App.css';
import ForgotPassword from "./components/forms/ForgotPassword";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PasswordReset from "./components/forms/PasswordReset";
import Confirm from "./components/pages/Confirm";


function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="forgotpassword" element={<ForgotPassword title="Password Dimenticata"/>}/>
                <Route path="passwordreset" element={<PasswordReset title="Resetta Password"/>}/>
                <Route path="registration" element={<Confirm title="Registrazione Completata!"/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
